module.exports = __webpack_public_path__ + "img/sendcheck.9046b6d9.jpeg";